import request from "@/utils/request.js";
import { currentUrlToParams } from "@/utils/common.js";
/**
 * 获取机构
 * @returns {AxiosPromise}
 */
export function getOrgByDomain(params) {
  return request({
    url: "/coreService/api/app/org/info/getByDomain",
    method: "post",
    data: { ...params, keyWord: currentUrlToParams("keyWord") }
    //23432432
  });
}
